import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import instance, { baseUrl } from "../../axios";
import { Autocomplete, Stack, TextField } from "@mui/material";
// MUI components

// Functional Component
function Mosques() {
  
  const [mosques, setMosques] = useState([]);
  const [search, setSearch] = useState("");
  useEffect(() => {
    instance.get(`api/mosques/results?search_query=${search}`).then((res) => {
      setMosques(res.data.data.mosques);
    });
  }, [search]);

  return (
    <div className="container mx-auto p-6 pt-[24px]">
    <h1 className="mb-[16px] text-xl font-normal text-[rgba(0, 0, 0, 0.87)]">
      Masjidlar
    </h1>

    {/* input group */}
    <div className="mb-[12px] flex justify-between space-x-2">
      <div>
        <Stack sx={{ background: "white", width: 300 }}>
          <Autocomplete
            size="small"
            freeSolo
            id="free-solo-2-demo"
            disableClearable
            options={mosques?.map((option) => option.name)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Qidirish"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  size: "small",
                }}
              />
            )}
          />
        </Stack>
      </div>
      <div></div>
    </div>

    <hr className="mb-[12px] bg-[rgba(0, 0, 0, 0.12)]" />

    {/* Mosque list cards */}
    <div className="grid">
      {mosques?.map((item) => {
        return (
          <Link
            key={item.id}
            to={`/mosque-info/${item.id}`}
            className="mb-[12px] flex w-full  h-[100px] bg-white rounded overflow-hidden"
            style={{
              boxShadow:
                "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)",
            }}>
            <img
              src={`${baseUrl}files/${item.image_src}`}
              alt="a mosque"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
              }}
            />
            <div className="px-[16px] py-[12px]">
              <p className="mb-[6px] font-[500] text-[#000000]">
                {item?.name}
              </p>
              <p
                className="flex mb-[17px]"
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "120%",
                  letterSpacing: "0.15px",
                  color: "#1A1A1A",
                }}>
                <img
                  src="../../images/icon-location-card.svg"
                  alt="icon"
                  width="10"
                  height="12"
                  className="mr-[4px]"
                />
                {item?.location}
              </p>
              <p
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "130%",
                  letterSpacing: "0.1px",
                  color: "#4D4D4D",
                }}>
                {item?.ads}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  </div>
  );
}


export default Mosques;